import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';

// Each letter will animate in from a random direction
const brand = "Algebracorp";
const directions = [
    { x: 0, y: -40 },   // top
    { x: 0, y: 40 },    // bottom
    { x: -40, y: 0 },   // left
    { x: 40, y: 0 },    // right
    { x: -30, y: -30 }, // top-left
    { x: 30, y: -30 },  // top-right
    { x: -30, y: 30 },  // bottom-left
    { x: 30, y: 30 },   // bottom-right
];

const Navbar: React.FC = () => {
    const [animKey, setAnimKey] = useState(0);
    const location = useLocation();

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimKey(prev => prev + 1);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <Link to="/" className="navbar-title" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img
                        src={logo}
                        alt="Algebracorp Logo"
                        style={{ height: "42px", width: "auto", marginRight: "7px" }}
                    />
                    <span className="brand-drop" key={animKey}>
                        {brand.split('').map((char, idx) => {
                            const dir = directions[idx % directions.length];
                            return (
                                <span
                                    className="drop-char"
                                    key={idx}
                                    style={{
                                        animationDelay: `${0.06 * idx + 0.18}s`,
                                        '--init-x': `${dir.x}px`,
                                        '--init-y': `${dir.y}px`,
                                        marginLeft: idx === 0 ? 0 : '-2px'
                                    } as React.CSSProperties}
                                >
                                    {char}
                                </span>
                            );
                        })}
                    </span>
                </Link>
            </div>
            <ul className="navbar-links">
                <li className={location.pathname === '/' ? 'active' : ''}>
                    <Link to="/">Home</Link>
                </li>
                <li className={location.pathname === '/about' ? 'active' : ''}>
                    <Link to="/about">About Us</Link>
                </li>
                <li className={location.pathname === '/product' ? 'active' : ''}>
                    <Link to="/product">Product</Link>
                </li>
                <li className={location.pathname === '/urbangro' ? 'active' : ''}>
                    <Link to="/urbangro">URBANGRO</Link>
                </li>
                <li className={location.pathname === '/healthcare' ? 'active' : ''}>
                    <Link to="/healthcare">Health Care</Link>
                </li>
                <li className={location.pathname === '/contact' ? 'active' : ''}>
                    <Link to="/contact">Contact Us</Link>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;